import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Intro from "../../elements/blocks/intro";
import Controls from "../../elements/blocks/controls";
import GroupCard from "../../elements/groups/group-card";
import TicketsMetrics from "../../elements/tickets/tickets-metrics";
import TicketsTable from "../../elements/tickets/tickets-table";
import AudiencesMetrics from "../../elements/campaigns/audience/audiences-metrics";
import InformationFieldsMetrics from "../../elements/tickets/information-fields-metrics";
import AudienceCards from "../../elements/campaigns/audience/audience-cards";
import Nope from "../../elements/blocks/nope";
import { useApiTenant } from "../../../api/api-tenant";
import { useAuth } from "../../../services/auth";
import { useRoles } from "../../../services/roles";
import { useTenancy } from "../../../services/tenancy";
import { flatGroups } from "../../../helpers/groups";
import analytics from "../../../helpers/analytics";
export default function CampaignView() {
    const { id } = useParams();
    return _jsx(CampaignViewComponent, {}, id);
}
function CampaignViewComponent() {
    var _a, _b, _c, _d;
    const { t } = useTranslation();
    const { id } = useParams();
    const api = useApiTenant();
    const auth = useAuth();
    const roles = useRoles();
    const tenancy = useTenancy();
    const [tab, setTab] = useState(process.env.APP_ID === "pias" && !roles.isAdmin ? "assigned" : "tickets");
    const [campaign, setCampaign] = useState(null);
    const [statusCount, setStatusCount] = useState(null);
    const [priorityCount, setPriorityCount] = useState(null);
    const [groups, setGroups] = useState([]);
    const [search, setSearch] = useState("");
    const [filteredGroups, setFilteredGroups] = useState(null);
    const [campaignVisible, setCampaignVisible] = useState(false);
    const [isCampaignLoading, setIsCampaignLoading] = useState(true);
    const [resetStatusAndPriorityCount, setResetStatusAndPriorityCount] = useState(false);
    const [range, setRange] = useState("none");
    const [startDate, setStartDate] = useState("");
    const [startTime, setStartTime] = useState("");
    const [endDate, setEndDate] = useState("");
    const [endTime, setEndTime] = useState("");
    const [isChosenGlobalCustomRange, setIsChosenGlobalCustomRange] = useState(false);
    const [count, setCount] = useState(false);
    const [countDisabled, setCountDisabled] = useState(false);
    const [countIsLoading, setCountIsLoading] = useState(false);
    const getCampaign = () => {
        api.GET_campaign(id)
            .then(response => {
            var _a, _b;
            if (roles.isAgent) {
                let related = [];
                let flatTenantGroups = [];
                if (roles.groupsTenant)
                    flatTenantGroups = flatGroups(roles.groupsTenant, 0, []);
                if (response.data.campaign.groups.length > 0) {
                    response.data.campaign.groups.map(group => {
                        flatTenantGroups.map(i => {
                            if (i.id === group.id) {
                                related.push(group);
                            }
                        });
                    });
                }
                if ((response.data.campaign.groups &&
                    response.data.campaign.active &&
                    ((_a = response.data.campaign.groups) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                    related.length > 0) ||
                    (response.data.campaign.active &&
                        ((_b = response.data.campaign.groups) === null || _b === void 0 ? void 0 : _b.length) === 0))
                    setCampaignVisible(true);
            }
            else
                setCampaignVisible(true);
            let groups = flatGroups(response.data.campaign.groups, 0, []);
            groups = groups.sort((a, b) => a.name.localeCompare(b.name));
            setGroups(groups);
            setCampaign(response.data.campaign);
            setIsCampaignLoading(false);
        })
            .catch(error => {
            if (!api.isCancel(error)) {
                console.error(error);
                setIsCampaignLoading(false);
            }
        });
    };
    const getStatusAndPriorityCount = () => {
        setCountDisabled(true);
        setCountIsLoading(true);
        api.GET_campaign(id, 1)
            .then(response => {
            setStatusCount(response.data.campaign.ticket_statuses);
            setPriorityCount(response.data.campaign.ticket_priorities);
            setCount(false);
            setCountDisabled(false);
            setCountIsLoading(false);
        })
            .catch(error => {
            if (!api.isCancel(error))
                console.error(error);
            setCount(false);
            setCountDisabled(false);
            setCountIsLoading(false);
        });
    };
    useEffect(() => {
        if (count)
            getStatusAndPriorityCount();
    }, [count]);
    useEffect(() => {
        if (!resetStatusAndPriorityCount)
            return;
        setStatusCount(null);
        setPriorityCount(null);
        setResetStatusAndPriorityCount(false);
    }, [resetStatusAndPriorityCount]);
    useEffect(() => {
        if (tab === "audiences" || tab === "reports")
            analytics.sendModalView("/tab/" + tab, auth.user);
        if (tab === "groups" || tab === "audiences")
            setSearch("");
    }, [tab]);
    useEffect(() => {
        setStartDate("");
        setStartTime("");
        setEndDate("");
        setEndTime("");
    }, [range]);
    useEffect(() => {
        let newGroups = [];
        if (search && search !== "") {
            groups &&
                groups.map(group => {
                    if (group.name.toLocaleLowerCase().includes(search.toLocaleLowerCase()))
                        newGroups.push(group);
                });
            setFilteredGroups(newGroups);
        }
        else {
            setFilteredGroups(null);
        }
    }, [search]);
    useEffect(() => {
        if (tenancy.isLoading)
            return;
        getCampaign();
        return () => api.cancel();
    }, [tenancy.isLoading]);
    const CampaignControls = () => {
        if (!campaign) {
            return null;
        }
        const hasGroups = campaign.groups && campaign.groups.length > 0;
        let tabs = [];
        if (process.env.APP_ID === "mcd") {
            if (roles.isAdmin) {
                tabs.push({ label: t("tickets.tickets"), value: "tickets" });
                if (hasGroups) {
                    tabs.push({ label: t("queues.queues"), value: "groups" });
                }
                if (campaign.type === "outbound") {
                    tabs.push({ label: t("campaigns.audiences.audiences"), value: "audiences" });
                }
                tabs.push({ label: t("campaigns.reports"), value: "reports" });
            }
        }
        else if (process.env.APP_ID === "pias") {
            if (roles.isAdmin) {
                tabs.push({ label: t("dashboard.all-tickets"), value: "tickets" });
            }
            tabs.push({ label: t("dashboard.assigned-to-me"), value: "assigned" }, { label: t("dashboard.my-drafts"), value: "drafts" }, { label: t("dashboard.my-schedule"), value: "scheduled" }, { label: t("dashboard.my-tickets"), value: "user" });
            if (roles.isManager || roles.isAgent) {
                tabs.push({ label: t("dashboard.all-tickets"), value: "tickets" });
            }
            if (hasGroups) {
                tabs.push({ label: t("queues.queues"), value: "groups" });
            }
            if (roles.isAdmin || roles.isManager) {
                if (campaign.type === "outbound") {
                    tabs.push({ label: t("campaigns.audiences.audiences"), value: "audiences" });
                }
                tabs.push({ label: t("campaigns.reports"), value: "reports" });
            }
        }
        else if (roles.isAdmin || roles.isManager) {
            tabs.push({ label: t("tickets.tickets"), value: "tickets" });
            if (hasGroups) {
                tabs.push({ label: t("queues.queues"), value: "groups" });
            }
            if (campaign.type === "outbound") {
                tabs.push({ label: t("campaigns.audiences.audiences"), value: "audiences" });
            }
            tabs.push({ label: t("campaigns.reports"), value: "reports" });
        }
        else {
            tabs.push({ label: t("tickets.tickets"), value: "tickets" });
            if (hasGroups) {
                tabs.push({ label: t("queues.queues"), value: "groups" });
            }
        }
        if (tabs.length === 0) {
            return null;
        }
        return (_jsx(Controls, { tabs: tabs, tab: tab, setTab: setTab, enableSearch: tab === "audiences" || tab === "groups", search: search, setSearch: setSearch, enableDateChanging: tab === "reports", range: range, setRange: setRange, startDate: startDate, setStartDate: setStartDate, startTime: startTime, setStartTime: setStartTime, endDate: endDate, setEndDate: setEndDate, endTime: endTime, setEndTime: setEndTime, setIsChosenGlobalCustomRange: setIsChosenGlobalCustomRange, setCount: tab === "tickets" && roles.isAdmin ? setCount : undefined, countDisabled: countDisabled, countIsLoading: countIsLoading, forceFullWidth: true }));
    };
    return (_jsxs(Fragment, { children: [_jsx(Intro, { name: campaign && campaignVisible
                    ? campaign.name
                    : t("campaigns.campaign") + " #" + id, breadcrumbs: (process.env.APP_ID !== "mcd" && !roles.isAgent) ||
                    (process.env.APP_ID === "mcd" && roles.isAdmin)
                    ? [
                        {
                            name: t("campaigns.campaigns"),
                            link: "/campaigns",
                        },
                        {
                            name: campaign && campaignVisible
                                ? campaign.name
                                : t("campaigns.campaign"),
                            link: "/campaigns/" + id,
                        },
                    ]
                    : [
                        {
                            name: campaign && campaignVisible
                                ? campaign.name
                                : t("campaigns.campaign"),
                            link: "/campaigns/" + id,
                        },
                    ], button: campaign && campaignVisible
                    ? tab === "audiences"
                        ? {
                            label: t("campaigns.audiences.new-audience"),
                            link: "/campaigns/" + id + "/audience/new",
                            color: "secondary",
                            type: "new",
                        }
                        : roles.isAdmin
                            ? {
                                label: t("campaigns.edit-campaign"),
                                link: "/campaigns/" + id + "/edit",
                                color: "primary",
                                type: "edit",
                            }
                            : process.env.APP_ID === "mcd" &&
                                !roles.isAdmin &&
                                ((_a = tenancy.client) === null || _a === void 0 ? void 0 : _a.domain) !== "naljepnice" &&
                                ((_b = tenancy.client) === null || _b === void 0 ? void 0 : _b.domain) !== "facility"
                                ? undefined
                                : {
                                    label: ((_c = tenancy.client) === null || _c === void 0 ? void 0 : _c.domain) === "naljepnice"
                                        ? t("tickets.new-order")
                                        : t("tickets.new-ticket"),
                                    link: "/campaigns/" + id + "/new-ticket",
                                    color: "secondary",
                                    type: "new",
                                }
                    : undefined, button2: tab !== "audiences" && campaign && campaign.type === "survey"
                    ? {
                        label: t("campaigns.go-to-survey"),
                        link: campaign.language === "hr" || campaign.language === "rs"
                            ? "/anketa/" + campaign.slug
                            : "/survey/" + campaign.slug,
                        color: "outlined",
                        type: "edit",
                    }
                    : undefined, button3: tab !== "audiences" && campaign && roles.isAdmin
                    ? {
                        label: ((_d = tenancy.client) === null || _d === void 0 ? void 0 : _d.domain) === "naljepnice"
                            ? t("tickets.new-order")
                            : t("tickets.new-ticket"),
                        link: "/campaigns/" + id + "/new-ticket",
                        color: "secondary",
                        type: "new",
                    }
                    : undefined, loading: isCampaignLoading }), isCampaignLoading ? (_jsx(Fragment, {})) : campaign && campaignVisible ? (_jsxs(Fragment, { children: [_jsx(CampaignControls, {}), tab === "tickets" && (_jsx(TicketsTable, { type: "campaign", campaign: campaign, setResetStatusAndPriorityCount: setResetStatusAndPriorityCount, user: campaign.type === "contract"
                            ? roles.userTenant
                                ? roles.userTenant
                                : undefined
                            : undefined, statusCount: statusCount, priorityCount: priorityCount, setCountDisabled: setCountDisabled })), tab === "assigned" && (_jsx(TicketsTable, { type: "assigned", campaign: campaign, user: roles.userTenant || undefined })), tab === "drafts" && (_jsx(TicketsTable, { type: "drafts", campaign: campaign, user: roles.userTenant || undefined })), tab === "scheduled" && (_jsx(TicketsTable, { type: "scheduled", campaign: campaign, user: roles.userTenant || undefined })), tab === "user" && (_jsx(TicketsTable, { type: "user", campaign: campaign, user: roles.userTenant || undefined })), tab === "audiences" && (_jsx(AudienceCards, { campaign: campaign, search: search ? search : "" })), tab === "groups" && (_jsx(Fragment, { children: filteredGroups !== null ? (_jsx(Grid, Object.assign({ container: true, spacing: 4, direction: "row", alignItems: "stretch" }, { children: filteredGroups.length > 0 ? (filteredGroups.map(group => (_jsx(GroupCard, { group: group, groups: groups }, group.id)))) : (_jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(Nope, { caption: t("queues.no-queues") }) }))) }))) : groups && groups.length > 0 ? (_jsx(Grid, Object.assign({ container: true, spacing: 4, direction: "row", alignItems: "stretch" }, { children: groups.map(group => (_jsx(GroupCard, { group: group, groups: groups, campaign: campaign }, group.id))) }))) : (_jsx(Nope, { caption: t("queues.no-queues") })) })), tab === "reports" && (_jsxs(Fragment, { children: [_jsx(TicketsMetrics, { type: "campaign", campaign: campaign, globalRange: range, setGlobalRange: setRange, globalStartDate: startDate, globalStartTime: startTime, globalEndDate: endDate, globalEndTime: endTime, isChosenGlobalCustomRange: isChosenGlobalCustomRange, setIsChosenGlobalCustomRange: setIsChosenGlobalCustomRange }), campaign.type === "outbound" && (_jsx(Fragment, { children: _jsx(AudiencesMetrics, { campaign_id: campaign.id, globalRange: range, setGlobalRange: setRange, globalStartDate: startDate, globalStartTime: startTime, globalEndDate: endDate, globalEndTime: endTime, isChosenGlobalCustomRange: isChosenGlobalCustomRange, setIsChosenGlobalCustomRange: setIsChosenGlobalCustomRange }) })), _jsx(InformationFieldsMetrics, { type: "campaign", campaign: campaign, information_type: "choice", globalRange: range, setGlobalRange: setRange, globalStartDate: startDate, globalStartTime: startTime, globalEndDate: endDate, globalEndTime: endTime, isChosenGlobalCustomRange: isChosenGlobalCustomRange, setIsChosenGlobalCustomRange: setIsChosenGlobalCustomRange }), _jsx(InformationFieldsMetrics, { type: "campaign", campaign: campaign, information_type: "field", globalRange: range, setGlobalRange: setRange, globalStartDate: startDate, globalStartTime: startTime, globalEndDate: endDate, globalEndTime: endTime, isChosenGlobalCustomRange: isChosenGlobalCustomRange, setIsChosenGlobalCustomRange: setIsChosenGlobalCustomRange })] }))] })) : (_jsx(Nope, { title: t("errors.404"), caption: t("campaigns.errors.not-found") }))] }));
}
